const API_ROUTES = {
  login: "login",
  senders: 'admin/sender',
  orders: 'admin/order',
  createRoute: 'admin/route/create'
};

export default API_ROUTES;
